/**
 * @class
 */
import Base from '@netx/core/lib/netx-model';

class Progress extends Base {
	/**
	 * @property {object}  defaults          - The default attribute values
	 * @property {boolean} defaults.active   - Progress is active
	 * @property {string}  defaults.message  - Progress message
	 * @property {number}  defaults.percent  - Progress percentage
	 */
	get defaults() {
		return {
			percent: 0,
			message: '',
			active: false,
		};
	}

	/** @override */
	constructor(attrs, opts = {}) {
		super(attrs, opts);

		// Use delay option if passed
		this.delay = opts.delay != null ? opts.delay : 1000;
	}

	/**
	 * @method
	 * @param {string} message Message
	 */
	complete(message) {
		this.set({
			message: message || '',
			percent: 100,
		});
		_.delay(() => {
			this.set({
				active: false,
				percent: 0,
			});
		}, this.delay);
	}

	/**
	 * We have no server methods - just cleanup
	 * @override
	 */
	destroy() {
		this.stopListening();
	}

	/**
	 * @method
	 */
	reset() {
		this.set(this.constructor.GetDefaults());
	}

	/**
	 * @method
	 * @param {number} percent Percent
	 * @param {string} message Message
	 */
	update(percent, message) {
		this.set({
			active: true,
			message: message || '',
			percent: percent,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'Progress';
	}
}

export default Progress;
